import React from "react";
import styles from "../DataTablePanel/styles.css";
import {useTranslation} from "react-i18next";

export default ({  groupHighlights }) => {
	const {t} = useTranslation();
	return (
		<>
			{groupHighlights && groupHighlights.options.length ? (
				<div className="idp-footer__middle advanced-settings">

					<div className="uk-width-1-2@s">

						<div className={styles.groupHighlightSelectContainer}>
							<span>{groupHighlights.header}:</span>

							<select className={styles.groupHighlightSelect} onChange={(e) => {
								groupHighlights.selected = e.target.value;
								groupHighlights.onChange(e);
							}} value={groupHighlights.selected}>
								<option value="">{t(`Select group to highlight`)}</option>
								{groupHighlights.options.map((option, index) => (
									<option key={index} value={option.value}>
										{option.text}
									</option>
								))}
							</select>
						</div>

					</div>
				</div>
			) : null}
		</>
	);
};
